module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cl":{"select":"Seleccione","00-03":"Menos de 3 meses","03-06":"De 3 a 6 meses","06-12":"De 6 meses a 1 año","12OrMore":"Más de 1 año","notDefined":"No esta definido","purchaseDate":"Fecha estimada de compra"}}')
  delete Component.options._Ctor
}
